import { authorizeManageMissionByMissionId } from '../../../../backend/features/permissions';
import { AuthError } from '@juvare/platform-app/App';
import { getShiftStorage } from '../utils/getShiftStorage';
export function canDenyVolunteers(userContext, { shiftId, status }) {
    const allowedStatuses = new Set(['deniedNotQualified', 'deniedRosterFull']);
    const shiftStorage = getShiftStorage(userContext);
    const shiftData = shiftStorage.get(shiftId).data;
    if (!authorizeManageMissionByMissionId(userContext, userContext.userState, shiftData.missionId)) {
        throw new AuthError('Unauthorized, user cannot deny volunteers');
    }
    if (!allowedStatuses.has(status)) {
        throw new AuthError('Participation status is incorrect');
    }
}
